module.exports = __webpack_public_path__ + "static/media/logo.4b316552.png";